import {
  api,
  cardDesignInitialValues,
  datesToISO,
  formHeaders,
  getAllGiftProject,
  getBanks,
  getCategories,
} from "@";
import type { CardDesignFormValues, ProjectFormValues } from "../types";
import { projectPayload } from "@/features/donations/projects/lib/helpers.ts";

// Function to toggle the active status of a project
export const toggleActive = (id: number, value: boolean) =>
  api.put(
    `api/adminproject/projects/${id}/change-active-status?isActive=${value}`,
  );

// Function to toggle the archived status of a project
export const toggleArchive = (id: number, value: boolean) =>
  api.put(
    `api/adminproject/projects/${id}/change-archived-status?isArchived=${value}`,
  );

export const getAdahiData = () =>
  Promise.all([
    api.get(`/api/AdminAdahi/GetAdahiProducts`),
    api.get(`/api/AdminAdahi/GetAdahiRitual`),
  ]);

// Function to get project data including banks, categories, and gift projects
export const getProjectData = () =>
  Promise.all([getBanks(), getCategories(), getAllGiftProject()]);

// Function to get a specific project by ID
export const getProject = (id: number | string) =>
  api.get(`/api/AdminProject/projects/${id}`);

// Function to save a project (create or update)
export const saveProject = (data: ProjectFormValues) => {
  const payload = projectPayload(data);

  if (payload.startsFrom) {
    payload.startsFrom = datesToISO(payload.startsFrom as string);
  }
  if (payload.endsTo) {
    payload.endsTo = datesToISO(payload.endsTo as string);
  }

  if (payload?.projectAttributes?.length > 0) {
    // make the dates ISO
    payload.projectAttributes = payload.projectAttributes.map((attr) => ({
      ...attr,
      verificationStartDate: attr.verificationStartDate
        ? datesToISO(attr.verificationStartDate)
        : "",
      verificationEndDate: attr.verificationEndDate
        ? datesToISO(attr.verificationEndDate)
        : "",
      endingTime: attr.endingTime ? datesToISO(attr.endingTime) : "",
    }));
  }

  const design =
    (payload.endowmentCertificateDesign as CardDesignFormValues[])?.[0] ||
    cardDesignInitialValues;
  payload.endowmentCertificateDesign = {
    content: "test",
    show: design.show || false,
    color: design.color || "#000000",
    xPercentage: parseInt(String(design.xWithTextWidth || 0)),
    yPercentage: parseInt(String(design.y || 0)),
    fontSize: design.fontSize || 16,
    fontFamily: 4,
    "shadow.x": design.shadowX || 0,
    "shadow.y": design.shadowY || 0,
    alignment: 1,
    hasShadow: design.hasShadow || false,
    "shadow.blur": design.shadowBlur || 0,
    disclaimer: design.disclaimer || 0,
    "border.color": design.borderColor || "#000000",
    "shadow.color": design.shadowColor || "#000000",
    "border.thickness": design.borderThickness || 0,
  };

  if (payload.id) {
    return api.put(
      `/api/AdminProject/projects/${payload.id}`,
      payload,
      formHeaders,
    );
  }
  return api.post("/api/AdminProject/projects", payload, formHeaders);
};
